import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { uniqWith, isEqual } from 'lodash';

const RoleTitle = styled.h6`
  color: ${props => props.theme.colors.text.primary};
  margin-bottom: ${props => props.theme.space.quarter};
  margin-top: 0;
`;

const OrganisationName = styled.div`
  color: ${props => props.theme.colors.darkerGrey};
  margin-bottom: ${props => props.theme.space.half};
`;

const ExperienceWrapper = styled.div`
  padding-left: ${props => props.theme.space.single};
`;

const WeployExperiences = ({ weployExperiences }) => (
  <Fragment>
    { uniqWith(weployExperiences, isEqual).map((weployExperienceData) => {
      const {
        title,
        organisationName,
      } = weployExperienceData;

      return (
        <ExperienceWrapper key={`${title}-${organisationName}`}>
          <RoleTitle>{title}</RoleTitle>
          <OrganisationName>{organisationName}</OrganisationName>
        </ExperienceWrapper>
      );
    })}
  </Fragment>
);

WeployExperiences.propTypes = {
  weployExperiences: PropTypes.array,
};

WeployExperiences.defaultProps = {
  weployExperiences: [],
};

export default WeployExperiences;
